import { render, staticRenderFns } from "./AppointmentsRecordModal.vue?vue&type=template&id=0cbedc3e&"
import script from "./AppointmentsRecordModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsRecordModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsRecordModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports